import Config from '@config';
import {
  FiltersGrid,
  Pagination,
  infiniteQueryOptions,
  normalizeInfiniteQueryData,
} from '@gasbi/shared/index';
import { createApi } from '@reduxjs/toolkit/query/react';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { ContractVolumePriceListItemReadModel } from './types';

export const contractVolumePricesApi = createApi({
  reducerPath: 'contractVolumePricesApi',
  baseQuery: axiosBaseQuery({ baseUrl: Config.VITE_API_URL }),
  tagTypes: ['ContractVolumePrices'],
  endpoints: builder => ({
    getContractVolumePricesI: builder.infiniteQuery<
      ContractVolumePriceListItemReadModel[],
      { contractId: string } & FiltersGrid,
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg: { contractId, ...filters }, pageParam }) => ({
        url: `/contracts/${contractId}/prices/by-volume/query`,
        method: 'GET',
        params: { ...filters, ...pageParam },
      }),
      providesTags: (_, __, { contractId }) => [
        { type: 'ContractVolumePrices', id: contractId },
      ],
    }),
  }),
});

export const useGetContractVolumePricesInfiniteQuery =
  normalizeInfiniteQueryData<ContractVolumePriceListItemReadModel>(
    contractVolumePricesApi.useGetContractVolumePricesIInfiniteQuery,
  );
